module.exports = __webpack_public_path__ + "static/media/25.6ba1cebf.png";